import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import { loginRequest, loginFail } from "store/actions/login";
import { showFailureNotification } from "store/actions/notification";

import PlantBackground from "components/Layouts/PlantBackground";
import Email from "components/common/Email";
import Password from "components/common/Password";

import styles from "./Login.module.css";

const Login = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loginError = useSelector((state) => state.authData?.loginError);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = (e) => {
    if (e.key === "Enter") {
      loginUser();
    }
  };

  const changeEmail = (e) => {
    const withoutSpaces = e.target.value.replace(/\s/g, ""),
      validator = new RegExp("^[A-Za-z0-9]+(?:[ _-][A-Za-z0-9]+)*$");

    setEmail(withoutSpaces);
  };

  const changePassword = (e) => {
    const withoutSpaces = e.target.value.replace(/\s/g, ""),
      validator = new RegExp("^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$");
    validator.test(withoutSpaces);

    setPassword(e.target.value);
  };

  const loginUser = () => {
    if (password.length > 0 && email.length > 0) {
      // gwt-admin loginRequest expects (password, email) in this order
      dispatch(loginRequest(password, email, history));
    }

    if (!password.length) {
      dispatch(showFailureNotification("Password field cannot be empty"));
    }

    if (!email.length) {
      dispatch(showFailureNotification("Email field cannot be empty"));
    }
  };

  useEffect(() => {
    if (loginError) {
      dispatch(showFailureNotification(loginError));
      dispatch(loginFail({ exception: null }));
    }
  }, [loginError, dispatch]);

  return (
    <PlantBackground>
      <div className={styles.container} onKeyUp={login}>
        <div className={styles.formContainer}>
          <label className={styles.label}>Sign in</label>
          <div className={styles.form}>
            <Email change={changeEmail} email={email} />
            <Password change={changePassword} password={password} />
            <div>
              <Link to="/resetpassword">
                <button className={styles.forgot} type="button">
                  Forgot password?
                </button>
              </Link>
            </div>
            <footer className={styles.footer}>
              <button
                onClick={loginUser}
                className={styles.submit}
                type="button"
              >
                Log in
              </button>
            </footer>
          </div>
        </div>
      </div>
    </PlantBackground>
  );
};

export default Login;
